
export enum FormState {
	Loading = "loading",
	Ready = "ready",
	Success = "success",
	Error = "error",
}

export const AnalysisCtaCookieName = "AnalysisFormCtaShown";
